/**
 * defa.views.UserForgotPasswordForm
 * A form for retrieving forgotten passwords.
 * @version 1.2.0
 */
import Form from 'scripts/poppet/form';
import template from 'templates/userForgotPasswordForm.jst.html';

const selectors              = {
	inputEmail    : '[data-input=forgot-email]',
	inputPassword1: '[data-input=forgot-password-1]',
	inputPassword2: '[data-input=forgot-password-2]',
	buttonLogin   : '[data-click=user-login]',
	buttonCreate  : '[data-click=user-create]',
	
};
const UserForgotPasswordForm = Form.extend( {
	
	// ------------------------------------------------
	// Setup
	// ------------------------------------------------
	
	template        : template,
	noInitValidation: true,
	
	ui: {
		email : selectors.inputEmail,
		login : selectors.buttonLogin,
		create: selectors.buttonCreate,
	},
	
	events: {
		'click @ui.login' : 'onClickLogin',
		'click @ui.create': 'onClickCreate',
	},
	
	
	// ------------------------------------------------
	// Event Handlers
	// ------------------------------------------------
	
	/**
	 * Triggers when a user requests to log in.
	 * @void
	 */
	onClickLogin: function ( event ) {
		event.preventDefault();
		this.trigger( 'nav', 'user:login' );
	},
	
	/**
	 * Triggers when a user requests to create a new account.
	 * @void
	 */
	onClickCreate: function ( event ) {
		event.preventDefault();
		this.trigger( 'nav', 'user:create' );
	},
	
	
	// ------------------------------------------------
	// Other functions
	// ------------------------------------------------
	
	submit: function () {
		
		this.model.forgotPassword( {
			email: this.ui.email.val().trim(),
			ref: this.getQueryValue('ref'),
			token: this.getQueryValue('token'),
		} );
	},
	
} );

export default UserForgotPasswordForm;
